import React,{useState,useRef,useMemo} from 'react';
import { Header ,Modal} from '../../../../components';
import { Button, message, Input, BackTop } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { useModal } from 'react-modal-hook';
import  Table  from '../components/Table';
import  Form  from '../components/Form';
import { useFetchUser,UseFetchCreateUser,UseFetchUpdateUser,UseFetchDeleteUser,useRemoveUserFromCompany} from "../hooks/useFetch";
import AddFromOtherCompany from '../components/AddFromOtherCompany';

function Users() {
  const { currentColor } = useStateContext();
  const [ dataEdit, setDataEdit] = useState(null);
  const companyId = sessionStorage.getItem('activeCompanyId')
  const { data:dataEmployees, isLoading:isLoadingEmployees ,refetch:refetchEmployees } = useFetchUser(companyId);
  const {  mutate: fetchUpdateUser } = UseFetchUpdateUser();
  const {  mutate: fetchCreateUser } = UseFetchCreateUser();
  const {  mutate: deleteUser } = UseFetchDeleteUser();

  const [isAddFromOtherOpen, setIsAddFromOtherOpen] = useState(false);
  const { mutateAsync: removeFromCompany } = useRemoveUserFromCompany();

  // ค้นหาชื่อผู้ใช้จากช่องบนหัวตาราง — กรองในฝั่งหน้าจอ ไม่ต้องยิง API ใหม่
  // (รายชื่อพนักงานต่อบริษัทมีหลักสิบ โหลดมาครบอยู่แล้ว)
  const [keyword, setKeyword] = useState('');
  const filteredEmployees = useMemo(() => {
    const k = keyword.trim().toLowerCase();
    if (!k) return dataEmployees;
    return (dataEmployees || []).filter((u) =>
      String(u.UserName ?? '').toLowerCase().includes(k)
    );
  }, [dataEmployees, keyword]);

  const titlePage = 'พนักงาน';
  const formAddRef = useRef(null); 
  const formEditRef = useRef(null); 
  
  //#region usehook model
  const [showAddModal, hideAddModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formAddRef.current.validateFields();
        const payload = {
          ...value,
          companyId: sessionStorage.getItem('activeCompanyId')
        }
        
        // TODO: FETCH API
        var result = await fetchCreateUser(payload)
        await message.destroy(); 
        await message.success('เพิ่มข้อมูลสำเร็จ');
        await hideAddModal();
        refetchEmployees()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถเพิ่มข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
        
      }
    };

    return (
      <Modal
        title={`เพิ่ม ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideAddModal}
      >
        <Form formRef={formAddRef}/>
      </Modal>
    );
  }, []);

  const [showEditModal, hideEditModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formEditRef.current.validateFields();
        const payload = {
          ...value,
          companyId: sessionStorage.getItem('activeCompanyId'),
          id: dataEdit.id
        }

        let result = await fetchUpdateUser(payload)

        await message.destroy(); 
        await message.success('แก้ไขขอมูลสำเร็จ');
        await hideEditModal();
        refetchEmployees()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถแก้ไขข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
      }
    };

    return (
      <Modal
        title={`แก้ไข ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideEditModal}
      >
        <Form formRef={formEditRef} initialValues={dataEdit}/>
      </Modal>
    );
  }, [dataEdit,isLoadingEmployees]);
    //#endregion


  const handleEdit = (record) => {
     setDataEdit(record);
     showEditModal()
  }

  // ถอนพนักงานที่ยืมมา — ไม่ใช่ลบบัญชี เจ้าตัวยังทำงานที่บริษัทต้นสังกัดได้ปกติ
  const handleRemoveGuest = async (record) => {
    try {
      await removeFromCompany({ id: record.id });
      message.success(`ถอน ${record.UserName} ออกจากบริษัทนี้แล้ว`);
      refetchEmployees();
    } catch (error) {
      message.error(error?.response?.data?.message || 'ถอนออกไม่สำเร็จ');
    }
  };

  const handleDelete = async (record) => {
    try {
      //isLoadingEmployees(true)
      await deleteUser(record.id)
      await message.destroy(); 
      await message.success('ลบสำเร็จ',2);
      refetchEmployees()
    } catch (error) {
      message.error('ไม่สามารถลบได้'); 
    } finally {
      await message.destroy(); 
      await hideEditModal();
    }
  }

  return (
    <div className="md:m-10">
      <div className="flex justify-between">
        <Header category="App" title={titlePage} />
        <div className="flex gap-2">
          <Button onClick={() => setIsAddFromOtherOpen(true)}>
            เพิ่มจากบริษัทอื่น
          </Button>
          <Button onClick={showAddModal} className='bg-blue-500 text-white'>
            เพิ่ม
          </Button>
        </div>
      </div>
      <div className="mt-4 mb-2 flex items-center gap-3">
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="ค้นหาชื่อผู้ใช้"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          style={{ maxWidth: 280 }}
        />
        {keyword.trim() && (
          <span className="text-gray-500 text-sm">
            พบ {filteredEmployees?.length ?? 0} คน จากทั้งหมด {dataEmployees?.length ?? 0} คน
          </span>
        )}
      </div>

      <Table data={filteredEmployees} onEdit={handleEdit} onDelete={handleDelete} onRefresh={refetchEmployees} onRemoveGuest={handleRemoveGuest}  loading={isLoadingEmployees} bordered />

      <AddFromOtherCompany
        open={isAddFromOtherOpen}
        onClose={() => setIsAddFromOtherOpen(false)}
        onAdded={refetchEmployees}
      />
    </div>
  );
}

export default Users;
